import { render, staticRenderFns } from "./projection.vue?vue&type=template&id=52decf69&scoped=true"
import script from "./projection.vue?vue&type=script&lang=js"
export * from "./projection.vue?vue&type=script&lang=js"
import style0 from "./projection.vue?vue&type=style&index=0&id=52decf69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52decf69",
  null
  
)

export default component.exports